/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Downpayment/view.blocks to change it.
import AmountOrPercentage from './AmountOrPercentage/index'
import React from 'react'
import Type from './Type/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Downpayment({
  children,
  viewPath = "/DesignSystem/DataVaxiomPatientInsuranceForm/OrthodonticCoverage/OrthoCoverage/Content/Downpayment"
  
}) {
  return (<React.Fragment
>
<div
  data-testid="Downpayment.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 weight="medium"
 text="Downpayment"
/>
<Type
  viewPath={`${viewPath}/Type`}
/>
<AmountOrPercentage
  viewPath={`${viewPath}/AmountOrPercentage`}
/>
</div>
{children}
</React.Fragment>)
}